export default "__VITE_ASSET__hEtGORbx__"